var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebSeriesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m14.671 7.928-3.527-2.116a1.254 1.254 0 0 0-1.259-.017 1.253 1.253 0 0 0-.635 1.088v4.233a1.25 1.25 0 0 0 1.893 1.072l3.528-2.117c.38-.228.607-.628.607-1.072s-.228-.844-.607-1.072zm-3.921 2.747v-3.35L13.542 9zm10 9.325a.75.75 0 0 1-.75.75h-2.25V21a.75.75 0 0 1-1.5 0v-.25H4a.75.75 0 0 1 0-1.5h12.25V19a.75.75 0 0 1 1.5 0v.25H20a.75.75 0 0 1 .75.75zM18 2.25H6A2.752 2.752 0 0 0 3.25 5v8A2.752 2.752 0 0 0 6 15.75h12A2.752 2.752 0 0 0 20.75 13V5A2.752 2.752 0 0 0 18 2.25zM19.25 13c0 .689-.561 1.25-1.25 1.25H6c-.689 0-1.25-.561-1.25-1.25V5c0-.689.561-1.25 1.25-1.25h12c.689 0 1.25.561 1.25 1.25z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebSeriesIcon);
export default __webpack_public_path__ + "static/media/web-series-icon.c92352163e6275d46fc8260abd391e58.svg";
export { ForwardRef as ReactComponent };